import React from 'react';
import './Projects.scss';
import useTitle from "../useTitle";
import loadLogo from '../../load.svg';

import Project from './Project';

const Projects = ( props ) => {

    useTitle( "Projects | Kalihackz" );

	const [ projectList, setProjectList ] = React.useState( [] );

	const [ total, setTotal ] = React.useState( '' );

    React.useEffect(() => {
		fetch( 'https://api.subrataghosh.repl.co/api/v1/projectsPart?pageSize=2&currentPage=None' )
        .then( function( resp ) {
            props.onLoad(50);
            return resp.json(); 
        } )
        .then( function( data ) {
            props.onLoad(100);
			if (data.success === 'true'){
				setTotal( data.total + '' );
				return setProjectList( data.items ); 
			}
			return '';
        } )
		.catch( (e) => console.log( 'Our API service is currently offline' ) );
    }, []);

	const projectElements = projectList.map( ( project ) => {
		return <Project key={project.id} project={project} id={project._id} />
	} );

	function handleSubmitNext( event ){

        event.preventDefault();
		var currentPage = projectList[projectList.length - 1]['_id'];
		fetch( `https://api.subrataghosh.repl.co/api/v1/projectsPart?pageSize=2&currentPage=${currentPage}` )
        .then( function( resp ) {
            props.onLoad(50);
            return resp.json(); 
        } )
        .then( function( data ) {
            props.onLoad(100);
			if (data.success === 'true'){

				setTotal( data.total + '' );
				return setProjectList( ( prevProjectList ) => {
					return [
						...prevProjectList,
						...data.items
					];
				} ); 
			}
			return '';
        } )
		.catch( (e) => console.log( 'Our API service is currently offline' ) );
		    
    }

    return (
        <>
        { 
            projectList.length === 0 ? 
            <main className="main-project" style={{alignItems: 'center'}}>
			    <img title="Loading Projects" src={loadLogo} alt="Loading Projects..." style={{width:"40%"}}/>
            </main>
            : 
            <main className="main-project">
            { projectElements }
            </main>
        }
        { projectList.length < total && <div className="navigater">
			<form onSubmit={handleSubmitNext}>
				<button className="input-btn">Load More</button>
			</form>
		</div> }
        </>
    );

}

export default Projects;